import {Injectable} from '@angular/core';
import {ApiService, EnvironmentModel} from '@cas-hub/acabim-common-client';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DocumentTypeService extends ApiService {
    constructor(protected client: HttpClient, protected environment: EnvironmentModel) {
        super(client, environment);
    }

    protected controller = 'document-type';

    public getDocumentUsageTypes(): Observable<any> {
        const params = new HttpParams().set('getAll', 'all');
        return this.client.get(this.url(''), {
            headers: this.defaultHeaders,
            params,
            responseType: 'json'
        });
    }

    public toggleDocumentUsageTypeStatus(usageTypeId: number): Observable<any> {
       return this.client.post(this.url(usageTypeId + '/status'), {
        headers: this.defaultHeaders,
        responseType: 'json'
       });
    }

    public addDocumentUsageType(usageTypeName: string): Observable<any> {
        return this.client.post(this.url(''), {name: usageTypeName}, {
            headers: this.defaultHeaders,
            responseType: 'json'
       });
    }

    public updateDocumentUsageType(usageTypeId: string, newUsageTypeName: string): Observable<any> {
         return this.client.post(this.url(usageTypeId), {name: newUsageTypeName}, {
            headers: this.defaultHeaders,
            responseType: 'json'
       });
    }
}
